import script from "./MoveMemory.vue?vue&type=script&setup=true&lang=js"
export * from "./MoveMemory.vue?vue&type=script&setup=true&lang=js"

import "./MoveMemory.vue?vue&type=style&index=0&id=8927bdc4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8927bdc4"]])

export default __exports__